import React from 'react'
import { Flex, Heading } from 'theme-ui'
import ContactDetails from '../../General/ContactDetails'
import { nanoid } from 'nanoid'

export default function LocationBoxes(props) {
  const {
    businessData,
    // configData,
    // pageTitle,
    // gonationID,
    locationIndex,
    variantName,
    options
  } = props

  const { containerStyles, containerID, titles, addresses, phoneNumbers, emails } = options

  const getOptionToLoopOver = () => {
    // finds the longest array out of the selected content data below and returns a object key
    const contentData = { titles, addresses, phoneNumbers, emails }
    let longestArrayIndex = null
    let longestArray = 0

    Object.values(contentData).forEach((content, index) => {
      if (content?.length > longestArray) {
        longestArray = content.length
        longestArrayIndex = index
      }
    })
    return Object.keys(contentData)[longestArrayIndex]
  }

  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  return (
    <Flex id={containerID ? containerID : ''} variant={`${variantName}.container`} sx={styles}>
      {options[getOptionToLoopOver()][locationIndex].map((location, index) => {
        const addressArray = options.addresses[locationIndex][index].split(',')
        const address = {
          name: businessData.name,
          street: addressArray[0],
          city: addressArray[1],
          state: addressArray[2],
          zip: addressArray[3]
        }
        return (
          <Flex variant={`${variantName}.box`} key={nanoid()}>
            <Heading variant={`${variantName}.title`}>{options.titles[locationIndex][index]}</Heading>
            <ContactDetails
              address={address}
              phone={options.phoneNumbers[locationIndex][index]}
              email={options.emails[locationIndex][index]}
            />
          </Flex>
        )
      })}
    </Flex>
  )
}
